import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { NavigationExtras, Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Smtp, SmtpForm } from '../../setting/model/model.class';
import { AlertComponent } from '../../shared/alert/alert.component';
import { AppComponentClass } from '../../shared/service/AppComponent.class';
import { ProfileService, SPSmtpService } from '../profile.service';
// import { CampaignregistryComponent } from '../../smssetup/campaignregistry/campaignregistry.component';
import { CampaignregistryComponent } from '../campaignregistry/campaignregistry.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-brandlist',
  templateUrl: './brandlist.component.html',
  styleUrls: ['./brandlist.component.css']
})
export class BrandlistComponent extends AppComponentClass<Smtp, SmtpForm> {
  key: any;
  isEnable: boolean = false;
  lengrec: any;
  // dialog: any;
  constructor(public dialog: MatDialog, protected data: SPSmtpService, public sdata:ProfileService, protected router: Router, protected fb: FormBuilder, protected msg: MatSnackBar) {
    super(data, router, fb, msg);
    this.key = parseInt(sessionStorage.getItem('iduser'));
    this.displayedColumns = ['campaign', 'did_limit', 'used_caller_id', 'remaining_caller_id'];
  }
  ngOnInit(): void {
    this.data.getCampList().subscribe((res: any) => {
      console.log(res);
      if ((res.result.length <= 5 || res.result.length <= '5') && (res.result[0].entity_type == 2)){
          this.lengrec = res.result.length
          this.isEnable = true
          this.dataSource.data =res.result;
        }else if(res.result.length <=1 && res.result[0].status == 1){
            this.lengrec = res.result.length
            this.isEnable = true
            this.dataSource.data =res.result;
        } else {
            this.isEnable = false;
          }
    }, err => {  
      this.isEnable = false
      this.dataSource.data = []
    });
  }
 
  addNewCampaign() {
    if (this.lengrec <= 5) {
      const dialogRef = this.dialog.open(CampaignregistryComponent, {
        width: '800px',
      });
      dialogRef.afterClosed().subscribe(result => {
        console.log(`Dialog result: ${result}`);
        this.data.getCampList().subscribe((res: any) => {
          console.log(res);
          if ((res.result.length <= 5 || res.result.length <= '5') && (res.result[0].entity_type == 2)){
              this.lengrec = res.result.length
              this.isEnable = true
              this.dataSource.data =res.result;
            }else if(res.result.length <=1 && res.result[0].status == 1){
                this.lengrec = res.result.length
                this.isEnable = true
                this.dataSource.data =res.result;
            } else {
                this.isEnable = false;
              }
        }, err => {  
          this.isEnable = false
          this.dataSource.data = []
        });
      });
    } else {
      const dialogRef = this.dialog.open(AlertComponent, {
        disableClose: true,
        width: '600px',
        data: {
          type: 101,
        }
      });
    }
  }

}
